export default __webpack_public_path__ + "static/media/setting.c9a5bb9c.svg";